// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--3a02c";
export var container = "styles-module--container--e4400";
export var desktop = "1340px";
export var giant = "2200px";
export var image = "styles-module--image--d7361";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";
export var template = "styles-module--template--4cce5";